import React from 'react';
import l from '../image/Contentss.webp';
import { Link } from 'react-router-dom';
const Services = () => {
  return (
    <div className="service_holders">
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-6 mb-5">
            <div>
              <div className="our_services">
                <span>Our Solution</span>
              </div>
              <div className="our_talks">
                <span>
                  AMT CAMEROUN SA is an experienced global provider of
                  integrated logistics, Transport and Marine services in modern
                  supply chain management.
                </span>
              </div>
            </div>
            <div className="mt-4">
              <div className="mb-3">
                <div className="holl">
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M19.71 2.83702C20.443 2.98402 21.016 3.55702 21.163 4.29002C21.2679 4.81523 21.2529 5.35735 21.1191 5.87595C20.9852 6.39454 20.736 6.87621 20.39 7.28502L17.639 10.537L19.583 17.668C19.641 17.8806 19.6418 18.1048 19.5852 18.3179C19.5287 18.5309 19.4168 18.7252 19.261 18.881L17.959 20.183C17.8484 20.2935 17.7137 20.3769 17.5654 20.4265C17.4172 20.4761 17.2595 20.4906 17.1047 20.4689C16.9498 20.4472 16.8022 20.3898 16.6733 20.3013C16.5444 20.2129 16.4379 20.0957 16.362 19.959L13.42 14.663L10.562 17.044L10.772 18.097C10.8126 18.2989 10.8027 18.5077 10.7432 18.7048C10.6837 18.9019 10.5765 19.0813 10.431 19.227L8.76696 20.89C8.65376 21.0031 8.51533 21.0876 8.36307 21.1366C8.21081 21.1857 8.04907 21.1979 7.89118 21.1722C7.73328 21.1465 7.58374 21.0837 7.45488 20.9889C7.32601 20.8941 7.22151 20.7701 7.14996 20.627L5.88996 18.11L3.37396 16.85C3.23088 16.7785 3.10684 16.674 3.01206 16.5451C2.91727 16.4162 2.85446 16.2667 2.82877 16.1088C2.80309 15.9509 2.81528 15.7892 2.86434 15.6369C2.9134 15.4847 2.99793 15.3462 3.11096 15.233L4.77496 13.569C4.92055 13.4237 5.09977 13.3165 5.29672 13.257C5.49366 13.1975 5.70225 13.1876 5.90396 13.228L6.95696 13.438L9.33796 10.581L4.04196 7.63802C3.90529 7.56213 3.78811 7.45555 3.69964 7.32667C3.61116 7.19779 3.55381 7.05014 3.53209 6.89533C3.51038 6.74052 3.5249 6.58279 3.5745 6.43454C3.62411 6.28629 3.70745 6.15159 3.81796 6.04102L5.11996 4.73902C5.27581 4.58318 5.4701 4.47131 5.68312 4.41476C5.89615 4.35821 6.12034 4.35899 6.33296 4.41702L13.463 6.36102L16.716 3.61002C17.1248 3.26401 17.6064 3.01478 18.125 2.88093C18.6436 2.74708 19.1858 2.73207 19.711 2.83702H19.71ZM19.218 4.78202C19.0026 4.75326 18.7836 4.7699 18.575 4.83087C18.3664 4.89183 18.1729 4.99578 18.007 5.13602L14.357 8.22502C14.2319 8.33076 14.0829 8.40449 13.923 8.43985C13.7631 8.47522 13.597 8.47116 13.439 8.42802L6.22596 6.46002L6.15896 6.52602L11.354 9.41202C11.4839 9.48422 11.5963 9.5842 11.6832 9.70485C11.77 9.8255 11.8292 9.96383 11.8564 10.11C11.8836 10.2561 11.8782 10.4065 11.8407 10.5503C11.8031 10.6941 11.7342 10.8279 11.639 10.942L8.11496 15.17C7.9986 15.3097 7.84669 15.4154 7.67526 15.476C7.50384 15.5365 7.31924 15.5497 7.14096 15.514L5.90396 15.267L5.49596 15.675L7.05296 16.454C7.26588 16.5605 7.43852 16.7331 7.54496 16.946L8.32496 18.503L8.73196 18.095L8.48496 16.858C8.44933 16.6797 8.46248 16.4952 8.52302 16.3237C8.58357 16.1523 8.68927 16.0004 8.82896 15.884L13.058 12.36C13.1721 12.2648 13.3059 12.1959 13.4497 12.1583C13.5935 12.1207 13.7439 12.1154 13.89 12.1426C14.0362 12.1698 14.1745 12.229 14.2951 12.3158C14.4158 12.4027 14.5158 12.5151 14.588 12.645L17.473 17.84L17.539 17.773L15.572 10.56C15.529 10.4019 15.5251 10.2358 15.5606 10.0758C15.5961 9.9159 15.6701 9.76702 15.776 9.64202L18.864 5.99202C19.149 5.65502 19.276 5.21602 19.218 4.78202Z"
                        fill="#233347"
                      />
                    </svg>
                  </div>
                  <div className="mx-3">
                    <div className="sub_head">
                      <span>International sea and air transport</span>
                    </div>
                    <div className="small_big_talks">
                      <span>
                        We provide end-to-end logistics services via AIR, 
                        SEA, responding swiftly to market demand. 
                        Our Less-than-Container Load service consolidates 
                        shipments into one container for efficient transport to Douala, 
                        where we handle transfer, warehousing, and deconsolidation, 
                        keeping clients informed throughout
                      </span>
                    </div>
                    <div className="learn_more">
                      <Link
                        to="/solutions"
                        style={{ textDecoration: 'none', color: 'inherit' }}
                      >
                        <span>
                          Learn more{' '}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M7.0001 13.0001H14.5901L11.2901 16.2901C11.1018 16.4784 10.996 16.7338 10.996 17.0001C10.996 17.2664 11.1018 17.5218 11.2901 17.7101C11.4784 17.8984 11.7338 18.0042 12.0001 18.0042C12.2664 18.0042 12.5218 17.8984 12.7101 17.7101L17.7101 12.7101C17.8011 12.615 17.8725 12.5028 17.9201 12.3801C18.0201 12.1366 18.0201 11.8635 17.9201 11.6201C17.8725 11.4973 17.8011 11.3852 17.7101 11.2901L12.7101 6.29006C12.6171 6.19633 12.5065 6.12194 12.3847 6.07117C12.2628 6.0204 12.1321 5.99426 12.0001 5.99426C11.8681 5.99426 11.7374 6.0204 11.6155 6.07117C11.4937 6.12194 11.3831 6.19633 11.2901 6.29006C11.1964 6.38302 11.122 6.49362 11.0712 6.61548C11.0204 6.73734 10.9943 6.86805 10.9943 7.00006C10.9943 7.13207 11.0204 7.26278 11.0712 7.38464C11.122 7.5065 11.1964 7.61709 11.2901 7.71006L14.5901 11.0001H7.0001C6.73489 11.0001 6.48053 11.1054 6.293 11.293C6.10546 11.4805 6.0001 11.7348 6.0001 12.0001C6.0001 12.2653 6.10546 12.5196 6.293 12.7072C6.48053 12.8947 6.73489 13.0001 7.0001 13.0001Z"
                              fill="#667085"
                            />
                          </svg>
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-3">
                <div className="holl">
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M22.4286 12.0479C22.4301 11.8283 22.3859 11.6107 22.2988 11.4091C22.2116 11.2075 22.0833 11.0262 21.9222 10.8769L12.1429 1.85718L2.36359 10.8769C2.20254 11.0263 2.07434 11.2075 1.98716 11.4091C1.89998 11.6107 1.85573 11.8283 1.85721 12.0479V20.8461C1.85721 21.2658 2.02393 21.6683 2.32069 21.9651C2.61745 22.2618 3.01994 22.4285 3.43963 22.4285H20.8462C21.2658 22.4285 21.6683 22.2618 21.9651 21.9651C22.2618 21.6683 22.4286 21.2658 22.4286 20.8461V12.0479Z"
                        stroke="black"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12.1443 22.0328C12.1443 22.4284 12.5399 22.4284 12.5399 22.4284H17.2855C17.6811 22.4284 17.6811 22.0328 17.6811 22.0328V17.2872C17.6811 16.8916 17.2855 16.8916 17.2855 16.8916H12.5399C12.1443 16.8916 12.1443 17.2872 12.1443 17.2872M12.1443 22.0328V17.2872M12.1443 22.0328C12.1443 22.0328 12.1443 22.4284 11.7487 22.4284H7.00302C7.00302 22.4284 6.60742 22.4284 6.60742 22.0328V17.2872C6.60742 17.2872 6.60742 16.8916 7.00302 16.8916H11.7487C11.7487 16.8916 12.1443 16.8916 12.1443 17.2872M9.77066 11.3531H14.5163C14.5163 11.3531 14.9119 11.3531 14.9119 11.7488V16.4944C14.9119 16.4944 14.9119 16.89 14.5163 16.89H9.77066C9.77066 16.89 9.37506 16.89 9.37506 16.4944V11.7488C9.37506 11.7488 9.37506 11.3531 9.77066 11.3531Z"
                        stroke="black"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                  <div className="mx-3">
                    <div className="sub_head">
                      <span>Warehousing</span>
                    </div>
                    <div className="small_big_talks">
                      <span>
                      Storage Area rental: offload, load cargo 
                      and rental of storage area inside yards 
                      or warehouses according to international standards
                      </span>
                    </div>
                    <div className="learn_more">
                      <Link
                        to="/solutions"
                        style={{ textDecoration: 'none', color: 'inherit' }}
                      >
                        <span>
                          Learn more{' '}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M7.0001 13.0001H14.5901L11.2901 16.2901C11.1018 16.4784 10.996 16.7338 10.996 17.0001C10.996 17.2664 11.1018 17.5218 11.2901 17.7101C11.4784 17.8984 11.7338 18.0042 12.0001 18.0042C12.2664 18.0042 12.5218 17.8984 12.7101 17.7101L17.7101 12.7101C17.8011 12.615 17.8725 12.5028 17.9201 12.3801C18.0201 12.1366 18.0201 11.8635 17.9201 11.6201C17.8725 11.4973 17.8011 11.3852 17.7101 11.2901L12.7101 6.29006C12.6171 6.19633 12.5065 6.12194 12.3847 6.07117C12.2628 6.0204 12.1321 5.99426 12.0001 5.99426C11.8681 5.99426 11.7374 6.0204 11.6155 6.07117C11.4937 6.12194 11.3831 6.19633 11.2901 6.29006C11.1964 6.38302 11.122 6.49362 11.0712 6.61548C11.0204 6.73734 10.9943 6.86805 10.9943 7.00006C10.9943 7.13207 11.0204 7.26278 11.0712 7.38464C11.122 7.5065 11.1964 7.61709 11.2901 7.71006L14.5901 11.0001H7.0001C6.73489 11.0001 6.48053 11.1054 6.293 11.293C6.10546 11.4805 6.0001 11.7348 6.0001 12.0001C6.0001 12.2653 6.10546 12.5196 6.293 12.7072C6.48053 12.8947 6.73489 13.0001 7.0001 13.0001Z"
                              fill="#667085"
                            />
                          </svg>
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-3">
                <div className="holl">
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="18"
                      viewBox="0 0 22 18"
                      fill="none"
                    >
                      <path
                        d="M2 1H13C13.2652 1 13.5196 1.10536 13.7071 1.29289C13.8946 1.48043 14 1.73478 14 2V13C14 13.2652 13.8946 13.5196 13.7071 13.7071C13.5196 13.8946 13.2652 14 13 14H2C1.73478 14 1.48043 13.8946 1.29289 13.7071C1.10536 13.5196 1 13.2652 1 13V2C1 1.73478 1.10536 1.48043 1.29289 1.29289C1.48043 1.10536 1.73478 1 2 1ZM21 14H14V7H17.5L21 10.231V14Z"
                        stroke="black"
                        stroke-width="2"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M14 15C14 15.5304 14.2107 16.0391 14.5858 16.4142C14.9609 16.7893 15.4696 17 16 17C16.5304 17 17.0391 16.7893 17.4142 16.4142C17.7893 16.0391 18 15.5304 18 15M3 15C3 15.5304 3.21071 16.0391 3.58579 16.4142C3.96086 16.7893 4.46957 17 5 17C5.53043 17 6.03914 16.7893 6.41421 16.4142C6.78929 16.0391 7 15.5304 7 15"
                        fill="#233347"
                      />
                      <path
                        d="M14 15C14 15.5304 14.2107 16.0391 14.5858 16.4142C14.9609 16.7893 15.4696 17 16 17C16.5304 17 17.0391 16.7893 17.4142 16.4142C17.7893 16.0391 18 15.5304 18 15M3 15C3 15.5304 3.21071 16.0391 3.58579 16.4142C3.96086 16.7893 4.46957 17 5 17C5.53043 17 6.03914 16.7893 6.41421 16.4142C6.78929 16.0391 7 15.5304 7 15"
                        stroke="black"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                  <div className="mx-3">
                    <div className="sub_head">
                      <span>Custom Clearance</span>
                    </div>
                    <div className="small_big_talks">
                      <span>
                        Our Customs specialists manage all processes related to
                        customs clearance of cargo, vessel and aircraft in
                        accordance with applicable customs regulations in
                        Cameroon
                      </span>
                    </div>
                    <div className="learn_more">
                      <Link
                        to="/solutions"
                        style={{ textDecoration: 'none', color: 'inherit' }}
                      >
                        <span>
                          Learn more{' '}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M7.0001 13.0001H14.5901L11.2901 16.2901C11.1018 16.4784 10.996 16.7338 10.996 17.0001C10.996 17.2664 11.1018 17.5218 11.2901 17.7101C11.4784 17.8984 11.7338 18.0042 12.0001 18.0042C12.2664 18.0042 12.5218 17.8984 12.7101 17.7101L17.7101 12.7101C17.8011 12.615 17.8725 12.5028 17.9201 12.3801C18.0201 12.1366 18.0201 11.8635 17.9201 11.6201C17.8725 11.4973 17.8011 11.3852 17.7101 11.2901L12.7101 6.29006C12.6171 6.19633 12.5065 6.12194 12.3847 6.07117C12.2628 6.0204 12.1321 5.99426 12.0001 5.99426C11.8681 5.99426 11.7374 6.0204 11.6155 6.07117C11.4937 6.12194 11.3831 6.19633 11.2901 6.29006C11.1964 6.38302 11.122 6.49362 11.0712 6.61548C11.0204 6.73734 10.9943 6.86805 10.9943 7.00006C10.9943 7.13207 11.0204 7.26278 11.0712 7.38464C11.122 7.5065 11.1964 7.61709 11.2901 7.71006L14.5901 11.0001H7.0001C6.73489 11.0001 6.48053 11.1054 6.293 11.293C6.10546 11.4805 6.0001 11.7348 6.0001 12.0001C6.0001 12.2653 6.10546 12.5196 6.293 12.7072C6.48053 12.8947 6.73489 13.0001 7.0001 13.0001Z"
                              fill="#667085"
                            />
                          </svg>
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mb-3">
                <div className="holl">
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M11.861 2.38999C12.3449 2.06755 12.912 1.89267 13.4935 1.88664C14.0749 1.8806 14.6455 2.04366 15.136 2.35599L19.29 4.99999H21C21.2652 4.99999 21.5196 5.10534 21.7071 5.29288C21.8946 5.48042 22 5.73477 22 5.99999V15C22 15.2652 21.8946 15.5196 21.7071 15.7071C21.5196 15.8946 21.2652 16 21 16H19.48C19.5121 16.4869 19.4091 16.9733 19.1823 17.4054C18.9556 17.8375 18.6139 18.1987 18.195 18.449L13.102 21.505C12.7891 21.6926 12.4308 21.791 12.0659 21.7896C11.701 21.7882 11.3435 21.687 11.032 21.497C10.6812 21.807 10.2327 21.9841 9.76472 21.9974C9.29675 22.0107 8.83892 21.8595 8.471 21.57L3.331 17.531C2.97186 17.2489 2.71999 16.8525 2.61721 16.4076C2.51443 15.9627 2.56694 15.496 2.766 15.085C2.52721 14.8978 2.33415 14.6587 2.20143 14.3858C2.06872 14.1129 1.99984 13.8134 2 13.51V5.99999C2 5.73477 2.10536 5.48042 2.29289 5.29288C2.48043 5.10534 2.73478 4.99999 3 4.99999H7.947L11.861 2.38999ZM4.173 13.646L4.865 13.041C5.45638 12.5237 6.22711 12.259 7.01154 12.3039C7.79596 12.3488 8.53148 12.6996 9.06 13.281L11.762 16.253C12.1857 16.7191 12.452 17.3067 12.5231 17.9325C12.5941 18.5584 12.4664 19.1908 12.158 19.74L17.167 16.735C17.298 16.6562 17.3974 16.5342 17.4482 16.39C17.4989 16.2458 17.4978 16.0884 17.445 15.945L13.018 9.74699C12.8968 9.57712 12.7254 9.44944 12.528 9.38183C12.3306 9.31423 12.1169 9.31008 11.917 9.36999L9.431 10.115C8.91221 10.2706 8.36097 10.2828 7.83577 10.1504C7.31058 10.018 6.83102 9.74594 6.448 9.36299L6.155 9.07099C5.88895 8.80547 5.70323 8.47026 5.6192 8.1039C5.53518 7.73754 5.55625 7.3549 5.68 6.99999H4V13.51L4.173 13.646ZM14.063 4.04399C13.8993 3.9397 13.7088 3.8853 13.5147 3.88743C13.3206 3.88956 13.1314 3.94813 12.97 4.05599L7.57 7.65599L7.862 7.94899C7.98981 8.07664 8.14981 8.16729 8.325 8.21131C8.50019 8.25533 8.68403 8.25107 8.857 8.19899L11.342 7.45399C11.9416 7.27418 12.5825 7.28645 13.1748 7.48908C13.7671 7.69172 14.2812 8.07456 14.645 8.58399L18.515 14H20V6.99999H19.291C18.9105 6.99994 18.5379 6.89136 18.217 6.68699L14.063 4.04399ZM6.181 14.545L4.565 15.959L9.705 19.998L10.41 18.766C10.5148 18.5825 10.5587 18.3705 10.5355 18.1605C10.5123 17.9505 10.4232 17.7532 10.281 17.597L7.58 14.625C7.40384 14.4313 7.15873 14.3144 6.89734 14.2995C6.63595 14.2845 6.37811 14.3727 6.181 14.545Z"
                        fill="black"
                      />
                    </svg>
                  </div>
                  <div className="mx-3">
                    <div className="sub_head">
                      <span>Personnel Support</span>
                    </div>
                    <div className="small_big_talks">
                      <span>
                        We provide a personalized service, considering the
                        various needs of individuals as they embark in often
                        challenging settings. We offer one dedicated point of
                        contact and ensure quality, flexibility and timeliness
                        in our service delivery.
                      </span>
                    </div>
                    <div className="learn_more">
                      <Link
                        to="/solutions"
                        style={{ textDecoration: 'none', color: 'inherit' }}
                      >
                        <span>
                          Learn more{' '}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M7.0001 13.0001H14.5901L11.2901 16.2901C11.1018 16.4784 10.996 16.7338 10.996 17.0001C10.996 17.2664 11.1018 17.5218 11.2901 17.7101C11.4784 17.8984 11.7338 18.0042 12.0001 18.0042C12.2664 18.0042 12.5218 17.8984 12.7101 17.7101L17.7101 12.7101C17.8011 12.615 17.8725 12.5028 17.9201 12.3801C18.0201 12.1366 18.0201 11.8635 17.9201 11.6201C17.8725 11.4973 17.8011 11.3852 17.7101 11.2901L12.7101 6.29006C12.6171 6.19633 12.5065 6.12194 12.3847 6.07117C12.2628 6.0204 12.1321 5.99426 12.0001 5.99426C11.8681 5.99426 11.7374 6.0204 11.6155 6.07117C11.4937 6.12194 11.3831 6.19633 11.2901 6.29006C11.1964 6.38302 11.122 6.49362 11.0712 6.61548C11.0204 6.73734 10.9943 6.86805 10.9943 7.00006C10.9943 7.13207 11.0204 7.26278 11.0712 7.38464C11.122 7.5065 11.1964 7.61709 11.2901 7.71006L14.5901 11.0001H7.0001C6.73489 11.0001 6.48053 11.1054 6.293 11.293C6.10546 11.4805 6.0001 11.7348 6.0001 12.0001C6.0001 12.2653 6.10546 12.5196 6.293 12.7072C6.48053 12.8947 6.73489 13.0001 7.0001 13.0001Z"
                              fill="#667085"
                            />
                          </svg>
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-6 mb-5">
            <div className="conoil">
              <img src={l} alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
